module.exports = __webpack_public_path__ + "assets/img/lucky.6be41ecc.png";